import React from "react";
import styles from "./style.module.scss";
import TimingDataManager from "../../../components/DataManagers/TimingDataManager";
import LoopHeatMap from "../../../components/Timing/LoopHeatMap";
import ImportsDataManager from "../../../components/DataManagers/ImportsDataManager";

function LoopHeatMapPage() {
  return (
    <div className={styles.fullscreen}>
      <TimingDataManager />
      <ImportsDataManager />
      <LoopHeatMap />
    </div>
  );
}

export default LoopHeatMapPage;
